import RcsUtils from './RcsUtils';

class RcsAdvManager {
  static eventHandlers() {
    document.addEventListener(
      'eventloadedBlDFP',
      () => {
        let bottomLeftAdv = document.querySelector('div#rcsad_BottomLeft');
        if (bottomLeftAdv !== null) {
          let parentBottomLeft = bottomLeftAdv.parentNode;
          if (RcsUtils.hasClass(parentBottomLeft, 'bk_adv_02')) {
            RcsUtils.addClass(parentBottomLeft, 'active-Bl');
          }
        }
      },
      false
    );

    document.addEventListener(
      'eventghostBlDFP',
      () => {
        let bottomLeftAdv = document.querySelector('div#rcsad_BottomLeft');
        if (bottomLeftAdv !== null) {
          let parentBottomLeft = bottomLeftAdv.parentNode;
          if (RcsUtils.hasClass(parentBottomLeft, 'bk_adv_02')) {
            RcsUtils.addClass(parentBottomLeft, 'ghost-Bl');
          }
        }
      },
      false
    );
  }

  static render(position, params = {}) {
    if (typeof RcsAdvManager[position] === 'function') {
      RcsAdvManager[position](params);
    }
  }

  static refreshBottom() {
    try {
      if (window.googletag && googletag.apiReady) {
        refreshBatchPageSlots('Bottom', '/Bottom', 'rcsad_Bottom');
      } else {
        document.addEventListener(
          'eventDFPready',
          () => {
            refreshBatchPageSlots('Bottom', '/Bottom', 'rcsad_Bottom');
          },
          false
        );
      }
    } catch (err) {}
  }

  static refreshBottom2() {
    try {
      if (window.googletag && googletag.apiReady) {
        refreshBatchPageSlots('Bottom2', '/Bottom2', 'rcsad_Bottom2');
      } else {
        document.addEventListener(
          'eventDFPready',
          () => {
            refreshBatchPageSlots('Bottom2', '/Bottom2', 'rcsad_Bottom2');
          },
          false
        );
      }
    } catch (err) {}
  }

  static refreshBottom3() {
    try {
      refreshBatchPageSlots('Bottom3', '/Bottom3', 'rcsad_Bottom3');
    } catch (err) {}
  }
}

module.exports = RcsAdvManager;



// WEBPACK FOOTER //
// ./src/rcs_cor_hp-lazy-loading/utils/RcsAdvManager.js